import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find} from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Card, Grid, Input, Dropdown, Checkbox, Dimmer, Loader} from 'semantic-ui-react';
import {setErrorMessage, clearErrorMessage} from '../../../../../common/components/form/common';
import {
  dateFormatShow, dateFormatPicker,
  noTimeZoneShortISODate, monthAndYear,
} from '../../../../../common/constants/datesFormat';
import {ofpStatus} from '../../../../../common/dictionaries/forms';
import {Actions} from '../../../../../common/actions';
import GeneralInfoRow from './generalInfoRow';
import ChassisInfoRow from './chassisInfoRow';
import FeaturesInfoRow from './featuresInfoRow';
import './generalInformation.scss';

class GeneralInformationTab extends Component {
  onChangeInputField = (field, value) => {
    this.onChangeValue(field, value);
  };

  onChangeDates = (field, date) => {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    this.onChangeValue(field, dateFormatted);
  }

  onCheckboxChange = (event, {name, value}) => {
    this.onChangeValue(name, value);
  }

  onChangeValue = (field, value, options) => {
    this.props.setGeneralInfo(field, value);
    if (field === 'agencyCode') {
      const optionSelected = find(options, {value});
      this.props.setGeneralInfo('agencyName', optionSelected.text);
    }
  }

  renderLabel(width, label) {
    return (
      <Grid.Column width={width}>
        <h4>{label}</h4>
      </Grid.Column>
    );
  }

  renderValue(width, value, className) {
    return (
      <Grid.Column width={width} className={className}>
        {value}
      </Grid.Column>
    );
  }

  getOfpStatusOptions() {
    return Object.keys(ofpStatus).map((item) => {
      return {'text': ofpStatus[item], 'value': item};
    });
  }

  renderLoader() {
    const {loading, loadingAgencies} = this.props;
    if (loading || loadingAgencies) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Cargando' />
        </Dimmer>
      );
    }
    return null;
  }

  render() {
    const {
      loadingAgencies,
      chassisInfo,
      generalInfo,
      isDisplayMode,
      type,
      formNumber,
      agenciesList,
      fetchChassisInfo,
    } = this.props;
    const saleDateFormatted = chassisInfo.saleDate ?
      moment(chassisInfo.saleDate).format(dateFormatShow) :
      '';
    const productionDateFormatted = chassisInfo.productionDate ?
      moment(chassisInfo.productionDate).format(monthAndYear) :
      '';

    return (
      <Card fluid raised>
        {this.renderLoader()}
        <Grid textAlign='left' className='general-information-container'>
          <GeneralInfoRow
            agenciesList={agenciesList}
            onChangeInputField={this.onChangeInputField}
            onChangeValue={this.onChangeValue}
            loadingAgencies={loadingAgencies}
            generalInfo={generalInfo}
            isDisplayMode={isDisplayMode}
            formNumber={formNumber}
            type={type}
          />

          <ChassisInfoRow
            generalInfo={generalInfo}
            chassisInfo={chassisInfo}
            isDisplayMode={isDisplayMode}
            fetchChassisInfo={fetchChassisInfo}
            onChangeValue={this.onChangeValue}
            onChangeInputField={this.onChangeInputField}
          />

          <Grid.Row>
            {this.renderLabel(1, 'Color')}
            {this.renderValue(2, chassisInfo.externalColor)}
            {this.renderLabel(2, 'País Origen')}
            {this.renderValue(2, chassisInfo.country)}
            {this.renderLabel(1, 'Nombre Cliente')}
            {this.renderValue(4, chassisInfo.clientName)}
            {this.renderLabel(2, 'Fecha Wholesale')}
            {this.renderValue(2, saleDateFormatted)}
          </Grid.Row>

          <FeaturesInfoRow
            generalInfo={generalInfo}
            isDisplayMode={isDisplayMode}
            onCheckboxChange={this.onCheckboxChange}
            productionDateFormatted={productionDateFormatted}
            onChangeInputField={this.onChangeInputField}
            onChangeDates={this.onChangeDates}
          />

          <Grid.Row>
            {this.renderLabel(2, 'Reparado')}
            <Grid.Column width={1}>
              <Checkbox
                name='isRepared'
                value={'YES'}
                checked={generalInfo.isRepared === 'YES'}
                onChange={this.onCheckboxChange.bind(this)}
                disabled={isDisplayMode}
                radio
              />
              SI
            </Grid.Column>
            <Grid.Column width={1}>
              <Checkbox
                name='isRepared'
                value={'NO'}
                checked={generalInfo.isRepared === 'NO'}
                onChange={this.onCheckboxChange.bind(this)}
                disabled={isDisplayMode}
                radio
              />
              NO
            </Grid.Column>

            {this.renderLabel(2, 'Fecha de Reparación')}
            <Grid.Column width={3}>
              <DatePicker
                customInput={<Input icon='calendar' size='small' />}
                dateFormat={dateFormatPicker}
                required={
                  generalInfo.isRepared && generalInfo.isRepared === 'YES'
                }
                disabled={
                  !(generalInfo.isRepared && generalInfo.isRepared === 'YES') ||
                  isDisplayMode
                }
                selected={
                  generalInfo.repairOfDate ?
                    moment(generalInfo.repairOfDate, noTimeZoneShortISODate).toDate() :
                    null
                }
                onChange={this.onChangeDates.bind(this, 'repairOfDate')}
                locale='es'
                placeholderText='Fecha de Reparación'
              />
            </Grid.Column>
            {this.renderLabel(2, 'No. de casos')}
            <Grid.Column width={3}>
              <Input
                type='text'
                value={generalInfo.casesNumber || ''}
                onChange={(e, {value}) => this.onChangeInputField('casesNumber', value)}
                onInvalid={setErrorMessage.bind(
                  this,
                  'Por favor, llene este campo'
                )}
                onInput={clearErrorMessage}
                disabled={isDisplayMode}
                placeholder='No. casos'
                autoComplete='off'
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            {this.renderLabel(2, 'Componente ID')}
            <Grid.Column width={11}>
              <Input
                type='text'
                value={generalInfo.componentId || ''}
                onChange={(e, {value}) => this.onChangeInputField('componentId', value)}
                onInvalid={setErrorMessage.bind(
                  this,
                  'Por favor, llene este campo'
                )}
                onInput={clearErrorMessage}
                disabled={isDisplayMode}
                placeholder='Componente ID'
                autoComplete='off'
              />
            </Grid.Column>
            {this.renderLabel(1, 'O.F.P.')}
            <Grid.Column width={2}>
              <Input
                type='text'
                value={generalInfo.ofp || ''}
                onChange={(e, {value}) => this.onChangeInputField('ofp', value)}
                onInvalid={setErrorMessage.bind(
                  this,
                  'Por favor, llene este campo'
                )}
                onInput={clearErrorMessage}
                disabled={isDisplayMode}
                required={false}
                placeholder='O.F.P.'
                autoComplete='off'
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            {this.renderLabel(2, 'Parte Corrección')}
            <Grid.Column width={3}>
              <Input
                type='text'
                value={generalInfo.correctPart || ''}
                onChange={(e, {value}) => this.onChangeInputField('correctPart', value)}
                onInvalid={setErrorMessage.bind(
                  this,
                  'Por favor, llene este campo'
                )}
                onInput={clearErrorMessage}
                disabled={isDisplayMode}
                placeholder='Parte Corrección'
                autoComplete='off'
              />
            </Grid.Column>
            {this.renderLabel(2, 'Estado del O.F.P.')}
            <Grid.Column width={3}>
              <Dropdown
                selection
                options={this.getOfpStatusOptions()}
                value={generalInfo.ofpStatus}
                onChange={(e, {value}) =>
                  this.onChangeValue('ofpStatus', value)
                }
                disabled={isDisplayMode}
                placeholder='Estado del O.F.P.'
              />
            </Grid.Column>
            {this.renderLabel(2, 'Responsable')}
            <Grid.Column width={4}>
              <Input
                type='text'
                name='responsible'
                value={generalInfo.responsible || ''}
                onChange={(e, {value}) => this.onChangeInputField('responsible', value)}
                onInvalid={setErrorMessage.bind(
                  this,
                  'Por favor, llene este campo'
                )}
                onInput={clearErrorMessage}
                disabled={isDisplayMode}
                placeholder='Responsable'
                autoComplete='off'
                required={true}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingAgencies': state.dealer.loadingAgencies,
    'agenciesList': state.dealer.agenciesList,
    'loading': state.templateFTR.loading,
    'chassisInfo': state.templateFTR.chassisInfo,
    'generalInfo': state.templateFTR.generalInfo,
    'type': state.templateFTR.type,
    'formNumber': state.templateFTR.formNumber,
  };
};

const {
  fetchChassisInfo,
  setGeneralInfo,
} = Actions;

export default connect(mapStateToProps, {
  fetchChassisInfo,
  setGeneralInfo,
})(GeneralInformationTab);
